import {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {SoopButtonCommon, SoopSectionTitle} from '@soop-ui/soop-ui';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {useGetFaqSearchList, useGetFaqSearchListInfinity} from '@/hooks/help';
import {saveFaqSearchHistory} from '@/api/help/search';
import FaqBoard from '@/components/help/common/FaqBoard';
import SearchArea from '@/components/help/common/SearchArea';
import {ROUTE} from '@/constants/main/route';
import styles from './Search.module.scss';

const HelpSearch = () => {
  const {isMobile} = useHelpContext();
  const [page, setPage] = useState(1);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const q = searchParams.get('q') || '';
  const pcResult = useGetFaqSearchList({searchWord: q, page});
  const mobileResult = useGetFaqSearchListInfinity({searchWord: q});
  const isLoading = isMobile ? mobileResult.isLoading : pcResult.isLoading;
  const count = isMobile ? mobileResult.data?.count : pcResult.data?.count;

  useEffect(() => {
    if (q) {
      // 키워드 바뀔 때 페이지 초기화
      setPage(1);

      // faq 키워드 검색 기록을 저장하는 api
      // 어드민 faq 키워드 관리 페이지에서 사용
      // 검색어가 70자 초과인 경우 저장하지 않음
      if (q.length <= 70) {
        try {
          saveFaqSearchHistory({searchWord: q});
        } catch (error) {}
      }
    }
  }, [q]);

  return (
    <div>
      <SearchArea />
      <div className={styles.SearchListWrapper}>
        <SoopSectionTitle className={styles.SearchSectionTitle}>
          <SoopSectionTitle.Title size='lg'>
            {!isMobile ? `'${q}' 검색결과` : '검색결과'}
            {!isLoading && <span className='subText'>({count || 0}건)</span>}
          </SoopSectionTitle.Title>
          <SoopSectionTitle.RightGroup className={styles.RightGroup}>
            <SoopButtonCommon
              variant='clearSecondary'
              endIconName='icoChevronLeft'
              size={32}
              onClick={() => navigate(ROUTE.HELP.FAQ)}>
              자주 묻는 질문
            </SoopButtonCommon>
          </SoopSectionTitle.RightGroup>
        </SoopSectionTitle>
        <FaqBoard
          type='search'
          {...(isMobile
            ? mobileResult
            : {
                ...pcResult,
                onPageChange: (page: number) => setPage(page),
              })}
        />
      </div>
    </div>
  );
};

export default HelpSearch;
